import axios from 'axios'

export const coreAPI = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
})

coreAPI.interceptors.request.use((config) => {
  const token = new URLSearchParams(window.location.search).get('accessToken')

  if (!token) {
    throw new Error('No access token found')
  }
  config.headers = config.headers ?? {}
  config.headers.Authorization = `Bearer ${token}`
  return config
})

const getUserDetail = async (userId: string) => {
  try {
    const response = await coreAPI.get(`v1/management/users/${userId}`)
    return response.data
  } catch (err) {
    throw err
  }
}

const getUserRecords = async (userId: string) => {
  try {
    const response = await coreAPI.get(`v1/management/users/${userId}/records`)
    return response.data.records
  } catch (err) {
    throw err
  }
}

const getRiskCategories = async () => {
  try {
    const response = await coreAPI.get(`v1/management/risk-categories`)
    return response.data.riskCategories
  } catch (err) {
    throw err
  }
}

const ManagementService = {
  getUserDetail,
  getUserRecords,
  getRiskCategories,
}

export default ManagementService
